/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "./AmountRaised.css";

import logo from "./Images/sensory.png";
import logo2 from "./Images/IMG_7057.jpeg";
import logo3 from "./Images/IMG_7055 (1).jpeg";
import { useConfig } from "../../context/ConfigContext";

export default function AmountRaised() {
  const { config } = useConfig();
  const API_URL = config.REACT_APP_API_URL;
  const API_KEY = config.REACT_APP_API_KEY;

  const [amount, setAmount] = useState(0);
  const [displayAmount, setDisplayAmount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [tileitems, settileitems] = useState([]);

  useEffect(() => {
    const fetchAmount = async () => {
      try {
        const res = await fetch(API_URL, {
          headers: { "Api-Key": API_KEY },
        });
        const data = await res.json();
        const total =
          Number(
            data?.donated?.amountDonated ??
              data?.amount ??
              data?.donatedAmount ??
              0
          ) || 0;
        setAmount(total);
        setDisplayAmount(total);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError(true);
        setLoading(false);
      }
    };

    fetchAmount();
  }, [API_URL, API_KEY]);

  useEffect(() => {
    const fetchAmount = async () => {
      try {
        
        const res = await fetch(API_URL, {
          headers: {
            "Api-Key": API_KEY,
          },
        });
        const data = await res.json();
        const total = Number(data.donated.amountDonated) || 0;
        setAmount(total);
        setLoading(false);
      } catch {
        setError(true);
        setLoading(false);
      }
    };

    fetchAmount();
  }, []);

  useEffect(() => {
    if (!loading && !error) {
      let start = 0;
      const duration = 3000;
      const end = amount;
      const stepTime = 16;
      const increment = (end - start) / (duration / stepTime);

      const counter = setInterval(() => {
        start += increment;
        if (start >= end) {
          start = end;
          clearInterval(counter);
        }
        setDisplayAmount(Math.round(start));
      }, stepTime);

      return () => clearInterval(counter);
    }
  }, [loading, error, amount]);

  const tiles =  [
    { "header": "New sensory room at Creech St Michael", image: logo, link: "https://woodenspoon.org.uk/recent-projects/star-sarah-bern-opens-new-sensory-room-at-creech-st-michael-primary-school/" },
    { "header": "The Beth Branson Education Hub", link: "https://stgilesanimalwelfare.co.uk/about-st-giles-animal-welfare/the-team-2/", yt: "https://www.youtube.com/embed/q97KLeaKqK8?si=lM5ZctfC28pG9dmw" },
    { "header": "Fundraising Handover", image: logo3, image2: logo2, description: "On 26th November 2025 (Bethany's Birthday), we had the pleasure of visiting our friends at St Giles Animal Welfare to hand over a cheque for £4350 as well as over a hundred dog toys donated by Bethany's team mates, the Wooden Spoon Barbarian players and friends and family - toys coming from as far away as Australia!!! St Giles are going to let the dogs choose a Christmas toy in the coming weeks." },
  ]

  useEffect(() => {
      const tileItems = tiles.map((e) => 
                    <div className="help-card">
                      <h4>{e.header}</h4>
                      {e.description !== "" && e.description !== undefined && (
                        <p>{e.description}</p>
                      )}
                      <img src={e.image} alt=""></img>
                      {e.image2 !== undefined && (
                        <img src={e.image2} alt=""></img>
                      )}
                      {e.link !== "" && e.link !== undefined && (
                        <a href={e.link}>Link to project</a>
                      )}
                      {e.yt !== "" && e.yt !== undefined && (
                        <iframe className="yt-frame" width="600" height="315" src={e.yt} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                      )}
                      </div>
                  )
                  settileitems(tileItems)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <section className="raised-page">
      <div className="center-block">
        {loading && <p className="faded">Loading total...</p>}
        {error && <p className="faded error">Unable to load the total. Please try again later.</p>}
        {!loading && !error && (
          <>
            <h2 className="raised-amount">£{displayAmount.toLocaleString()}</h2>
            <p className="thank-you">
              Thank you to everyone who has donated. Your kindness and generosity help us continue to honour Beth’s
              memory in a meaningful way.
            </p>

            <div className={`accordion ${isOpen ? "open" : ""}`}>
              <button className="accordion-toggle" onClick={() => setIsOpen(!isOpen)}>
                How your donations have helped
              </button>
              <div className="accordion-content">
                <div className="help-cards">
                  {tileitems}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
}